import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import { uploadTransformationUrl } from '@dmi-mch/utils';
/**
 * Given a obj and a number, it looks for image URLs in the obj by stringifying it, and sets the width passed in pxNum
 * @param {*} object
 * @param {*} pxNum
 */

var limitWidthImagesInString = function limitWidthImagesInString(obj, pxNum) {
  var stringified = _JSON$stringify(obj);

  var regex = /\b(https?:\/\/\S*?\.(?:png|jpe?g|gif)(?:\?(?:(?:(?:[\w_-]+=[\w_-]+)(?:&[\w_-]+=\w_-]+)*)|(?:[\w_-]+)))?)\b/igm;
  var match = stringified.match(regex);

  if (match) {
    stringified = stringified.replace(regex, function (matchText) {
      return uploadTransformationUrl(matchText, "q_auto,c_limit,w_".concat(pxNum));
    });
  }

  return JSON.parse(stringified);
};

export default limitWidthImagesInString;